export const countryChangeEventBus = new EventTarget();

export interface ICountryChangeValidationDetail {
    targetCountry: string;
    targetLang: string;
    redirectUrl?: string;
}

export class BeforeCountryChangeEvent extends CustomEvent<ICountryChangeValidationDetail> {

    public constructor( targetCountry: string, targetLang: string ) {

        super( 'before-country-change', {
            detail: {
                targetCountry,
                targetLang,
                redirectUrl: undefined
            },
            cancelable: true
        });

    }

}

export const COUNTRY_CHANGE_EVENTS = {
    BEFORE_CHANGE: 'before-country-change'
} as const;
